module.exports = "<div [formGroup]=\"form\" class=\"form-group\">\n  <label class=\"col-sm-2 control-label\">{{displayName}}</label>\n  <div class=\"col-sm-10\">\n    <!-- <tag-input [modelAsStrings]=\"true\" [formControlName]=\"field\" class=\"form-control\"></tag-input> -->\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/admin/shared/formcontrol-array/formcontrol-array.component.html
// module id = 298
// module chunks = 0 1